export const trimTrailingSlash = (url: string): string => (url.endsWith('/') ? url.slice(0, url.length - 1) : url);
export const ensureEndingSlash = (url: string): string => `${trimTrailingSlash(url)}/`;
